
<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Behfa Equipment Usage Report</h5>
     <br/>

     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Check-out Range Start </label>
        <input type="text" #datepickerInputStartDaryaft placeholder="Type here..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStartDaryaft"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Check-out Range End  </label>
        <input type="text" #datepickerInputEndDaryaft  placeholder="Type here..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEndDaryaft"></ng-persian-datepicker>
      </div>
      </div>
     <br>
     <br>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Check-in Range Start   </label>
        <input type="text" #datepickerInputStartTahvil placeholder="Type here..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStartTahvil"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Check-in Range End </label>
        <input type="text" #datepickerInputEndTahvil  placeholder="Type here..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEndTahvil"></ng-persian-datepicker>
      </div>
      </div>
     <br>
     <br>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Code BEHFA</label>
        <input [(ngModel)]="Filter_Code_BEHFA" (keyup)="Change_Filter()" name="Filter_Code_BEHFA" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> User </label>
        <select class="custom-select" [(ngModel)]="selectedUser" >
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_User" [value]="item.username">
            {{item.name}} {{item.familly}}
          </option>
        </select>
      </div>

    </div>
     <div class="row">
      <div  class="form-group col-md-12" >
        <button  type="button" (click)="ReadData_DeviceBehfa(datepickerInputStartDaryaft.value,datepickerInputEndDaryaft.value,datepickerInputStartTahvil.value,datepickerInputEndTahvil.value)" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>

     </div>

     <br>
     <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Receipt Number</th>
              <th>Customer Name</th>
              <th>Usage Duration</th>
              <th>Group</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Certificate No.</th>
              <th>Cal. Due</th>
              <th>Name User</th>
              <th>Reception Date</th>
              <th>Delivery Date</th>
              <th>Verified By</th>
              <th>Verification Date</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            |filter:Filter_Code_BEHFA:'codeBEHFA'
            |filter:Filter_Code_User:'username'
            |filter:Filter_Code_Group:'groupTitle'
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (
                          DataList_DeviceBehfa
                          |filter:Filter_Code_BEHFA:'codeBEHFA'
                          |filter:Filter_Code_User:'username'
                          |filter:Filter_Code_Group:'groupTitle'
                          ).length
                      }
            " >
            <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.customerName}}</td>
            <td>{{item.persianDate}}</td>
            <td>{{item.groupTitle}}</td>
            <td>{{item.description}}</td>
            <td>{{item.manufacturer}}</td>
            <td>{{item.model}}</td>
            <td>{{item.codeBEHFA}}</td>
            <td>{{item.certificateNo}}</td>
            <td>{{item.calDue}}</td>
            <td>{{item.username}}</td>
            <td>{{item.downloadDate}}</td>
            <td>{{item.uploadDate}}</td>
            <td>{{item.confirmer}}</td>
            <td>{{item.confirmerDate}}</td>
            <td>{{item.dsc}}</td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_DeviceBehfaTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>



<table id="excel-table" style="display: none;" >
  <thead >
    <tr>
      <th>#</th>
      <th>Receipt Number</th>
      <th>Customer Name</th>
      <th>Usage Duration</th>
      <th>Group</th>
      <th>Description</th>
      <th>Manufacturer</th>
      <th>Model</th>
      <th>Code BEHFA</th>
      <th>Certificate No.</th>
      <th>Cal. Due</th>
      <th>Name User</th>
      <th>Reception Date</th>
      <th>Delivery Date</th>
      <th>Verified By</th>
      <th>Verification Date</th>
      <th>Description</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_DeviceBehfa
    |filter:Filter_Code_BEHFA:'codeBEHFA'
    |filter:Filter_Code_User:'username'
    |filter:Filter_Code_Group:'groupTitle'" >
    <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
    <td>{{item.code}}</td>
    <td>{{item.customerName}}</td>
    <td>{{item.persianDate}}</td>
    <td>{{item.groupTitle}}</td>
    <td>{{item.description}}</td>
    <td>{{item.manufacturer}}</td>
    <td>{{item.model}}</td>
    <td>{{item.codeBEHFA}}</td>
    <td>{{item.certificateNo}}</td>
    <td>{{item.calDue}}</td>
    <td>{{item.username}}</td>
    <td>{{item.downloadDate}}</td>
    <td>{{item.uploadDate}}</td>
    <td>{{item.confirmer}}</td>
    <td>{{item.confirmerDate}}</td>
    <td>{{item.dsc}}</td>
    </tr>
  </tbody>
</table>
